import { Avatar, Box, Button, Grid2, Modal, Tab, Tabs, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import shuttleDetails from '../../assets/images/shuttleDetails.svg';
import connectAddress from '../../assets/images/connectAddress.svg';
import starIcon from '../../assets/icons/starIcon.png';
import React, { useEffect, useRef, useState } from "react";
import altProfile from '../../assets/images/altProfile.png';
import config from '../../config/config.js';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import routeMarker from '../../assets/images/routeMarker.svg';
import yellowRouteMarker from '../../assets/images/yellowRouteMarker.svg';
import greyRouteMarker from '../../assets/images/greyRouteMarker.svg';
import { useLocation } from "react-router-dom";
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import currentStopIcon from '../../assets/icons/currentStopIcon.svg';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import redDropIcon from '../../assets/icons/redDropIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { GoogleMap, Marker, Polyline, useJsApiLoader } from "@react-google-maps/api";
import passengerSeat from '../../assets/icons/passengerSeat.svg';
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";


const LIBRARIES = ["maps", "drawing", "places", "geometry"];
var constants = require('../../constant');

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
}
  
CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
  
function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

const ShuttleMapViewDetails = () => {

    const [value, setValue] = useState(0);
    const location = useLocation();
    const marker = location.state?.marker;
    const mapRef = useRef(null);
    const [center, setCenter] = useState({lat: 28.644800, lng: 77.216721});
    const [openPassengerModal, setOpenPassengerModal] = useState(false);
    const [currentStopName, setCurrentStopName] = useState('');
    const [currentStopAddress, setCurrentStopAddress] = useState('');
    const serverUrl = config.serverUrl;

    const [polylineVisible, setPolylineVisible] = useState(false);
    const [passengerModalData, setPassengerModalData] = useState([]);

    const [currentBluePolyline, setCurrentBluePolyline] = useState(null);
    const [currentGreyPolyline, setCurrentGreyPolyline] = useState(null);
    const [bluePath, setBluePath] = useState([]);
    const [greyPath, setGreyPath] = useState([]);
    const clientdataShown = localStorage.getItem('hideuserinfo');
    const driverDataShown = localStorage.getItem('hidedriverinfo');

    useEffect(() => {
        if (marker?.trip_details?.route_details?.length > 1) {
            const routeDetails = marker.trip_details.route_details;
            
            // Split stops into completed and remaining
            let completedStops = [];
            let remainingStops = [];
            
            routeDetails.forEach((stop) => {
                if (stop.is_arrived || stop.is_skipped) {
                    completedStops.push(stop);
                } else {
                    // If this is the first remaining stop and we have completed stops,
                    // add the last completed stop to create a connection
                    if (remainingStops.length === 0 && completedStops.length > 0) {
                        remainingStops.push(completedStops[completedStops.length - 1]);
                    }
                    remainingStops.push(stop);
                }
            });

            // Convert stops to path coordinates
            const completedPath = completedStops.map(stop => ({
                lat: Number(stop.latitude),
                lng: Number(stop.longitude)
            }));

            const remainingPath = remainingStops.map(stop => ({
                lat: Number(stop.latitude),
                lng: Number(stop.longitude)
            }));

            setBluePath(completedPath);
            setGreyPath(remainingPath);
        }
    }, [marker]);

    // const loaderOptions = {
    //     id: 'google-map-script',
    //     googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES,
    // }
    const { isLoaded, loadError } = useGoogleMapsLoader();
    const [map, setMap] = useState(null)
    const containerStyle = {
        width: '100%',
        height: '500px',
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        maxHeight:"700px",
        borderRadius:'8px',
        overflowY:'auto'
    };

    const handleClose = () => setOpenPassengerModal(false);
    
    const onLoad = React.useCallback((map) => {
        console.log('Map loaded successfully');
        setMap(map); // Store the map instance
    }, []);
    
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, []);

    useEffect(() => {
        if (marker?.trip_details?.route_details?.length > 0 && map) {
    
            const bounds = new window.google.maps.LatLngBounds();
            marker.trip_details.route_details.forEach((stop) => {
                if (stop.latitude && stop.longitude) {
                    bounds.extend(new window.google.maps.LatLng(Number(stop.latitude), Number(stop.longitude)));
                }
            });
    
            map.fitBounds(bounds); // Ensure all stops are visible
    
            // Force polyline to update
            setPolylineVisible(false);
            setTimeout(() => {
                setPolylineVisible(true);
            }, 50);
        }
    }, [marker, map]);

    const openPassengerDetails = async(stop) => {
        setOpenPassengerModal(true);
        setCurrentStopAddress(stop.address);
        setCurrentStopName(stop.name);
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = serverUrl + "/shuttle/fetch_stop_passenger_details";
            const obj={
                token: token,
                stop_id: stop.stop_id,
                session_id: marker?.trip_details?.session_id
            }
            const response =  await makeGetRequestToUrl(url, obj);
            
            // if(response.flag==102){
            //     console.log('Token is expired. Please login again')
            //     localStorage.removeItem('token');
            //     setErrorMessage('Your session has expired. Please log in again.');
            //     setTokenExpired(true);
            //     setTimeout(() => {
            //         navigate('/signup');
            //     }, 2000);
            // }

            if(response.flag === 200){
                const mapViewData = response.data;
                console.log('mapViewData==', mapViewData)
                setPassengerModalData(mapViewData);
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return(
        <div>
            <Grid2 className="mainBox">
                <Grid2 container item spacing={6}>
                    <Grid2 item>
                        <Grid2 item className='detailsHead'>Route ID</Grid2>
                        <Grid2 item className='detailsText'>{marker.trip_details.route_id}</Grid2>
                    </Grid2>
                    <Grid2 item className='detailsHead'>
                        <img src={shuttleDetails} alt="shuttle details" style={{marginTop:'12px'}} />
                    </Grid2>
                    <Grid2 item>
                        <Grid2 item className='detailsHead'>Economy</Grid2>
                        <Grid2 item className='detailsText'>{marker.trip_details.vehicle_number}</Grid2>
                    </Grid2>
                    <Grid2 item sx={{backgroundColor:'#F9F9F9', display:'flex', alignItems:'center', padding:'8px', borderRadius:'8px'}}>
                        <Typography sx={{marginRight:'8px'}}>{marker.trip_details.pickup_stop_name}</Typography>
                        <img src={connectAddress} alt="connect address" height="70%" width="70%" />
                        <Typography sx={{marginLeft:'8px'}}>{marker.trip_details.drop_stop_name}</Typography>
                    </Grid2>

                    <Grid2 item sx={{marginTop:'24px', marginLeft:'auto'}}>
                        <Button
                            variant="contained"
                            style={{
                                // backgroundColor: driverCurrentStatus==0 ? '#F9E9E9' : '#E7F8F2',
                                // color: driverCurrentStatus==0 ? '#D14545' : '#0DBA78',
                                textTransform: 'none', pointerEvents: 'none', borderRadius: '6px', minWidth: '60px',
                                border:'none', boxShadow: 'none', fontFamily: 'Poppins', height:'24px',
                                // border: driverCurrentStatus==0 ? '1px solid #D14545' : '1px solid#36C68F'
                            }}
                        >
                            <FiberManualRecordIcon style={{ fontSize: '12px' }}/> Online
                            {/* {driverCurrentStatus == 0 ? 'Offline' : 'Online'} */}
                        </Button>
                    </Grid2>
                </Grid2>

                <hr/>

                <Box sx={{ width: '100%' }}>
                    <Box sx={{borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="Trip Details" {...a11yProps(0)} 
                            sx={{textTransform: 'none', border:'1px solid #D1D5DB', marginRight:'12px', borderRadius:'10px', '&.Mui-selected': { color: 'white', backgroundColor:'#0065ff', borderBottom:'' },}} />
                            <Tab label="Driver Info" {...a11yProps(1)} 
                            sx={{textTransform: 'none', border:'1px solid #D1D5DB', marginRight:'12px', borderRadius:'10px', '&.Mui-selected': { color: 'white', backgroundColor:'#0065ff', borderBottom:'' },}} />
                            <Tab label="Route & Passenger Info" {...a11yProps(2)} 
                            sx={{textTransform: 'none', border:'1px solid #D1D5DB', marginRight:'12px', borderRadius:'10px', '&.Mui-selected': { color: 'white', backgroundColor:'#0065ff', borderBottom:'' },}} />
                            <Tab label="Vehicle Details" {...a11yProps(3)} 
                            sx={{textTransform: 'none', border:'1px solid #D1D5DB', marginRight:'12px', borderRadius:'10px', '&.Mui-selected': { color: 'white', backgroundColor:'#0065ff', borderBottom:'' },}} />
                        </Tabs>
                    </Box>

                </Box>
            </Grid2>

            <Grid2 container item spacing={2} sx={{display:'flex'}}>
                <Grid2 item size={4.5} className="mainBox" sx={{marginTop:'1%',overflowY: 'auto',paddingRight: '12px',maxHeight: '64vh'}}>

                    <CustomTabPanel value={value} index={0}>
                        <Typography sx={{color:'#2A313C', fontSize:'20px', fontWeight:'600'}}>Trip Details</Typography>

                        <Grid2 sx={{marginTop:'2%', backgroundColor:'#F9F9F9', borderRadius:'10px'}}>
                            <Grid2 item container sx={{padding:'2%', marginTop:'2%', alignItems:'center'}}>
                                <Grid2 item size={1}>
                                    <img src={pickupMarker} alt="pickup marker" width="20px" height="20px" />
                                </Grid2>
                                <Grid2 item size={11}>
                                    <Typography sx={{color:'#83888E', fontSize:'12px'}}>Starting Point</Typography>
                                    <Typography sx={{fontSize:'14px'}}>{marker.trip_details?.pickup_stop_address}</Typography>
                                </Grid2>
                            </Grid2>
                            <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB', marginLeft:'36px'}} />

                            <Grid2 item container sx={{padding:'2%', alignItems:'center'}}>
                                <Grid2 item size={1}>
                                    <img src={dropMarker} alt="drop marker" width="20px" height="20px" />
                                </Grid2>
                                <Grid2 item size={11}>
                                    <Typography sx={{color:'#83888E', fontSize:'12px'}}>End Point</Typography>
                                    <Typography sx={{fontSize:'14px'}}>{marker.trip_details?.drop_stop_address}</Typography>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Route ID</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.trip_details.route_id}</Typography>
                        </Grid2>
                        <hr/>
                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Vehicle Type</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>Shuttle</Typography>
                        </Grid2>
                        <hr/>
                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Trip Start Time</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>
                            {new Date(marker.trip_details.start_time).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true
                            })}
                                {/* {marker.trip_details.start_time} */}
                            </Typography>
                        </Grid2>
                        <hr/>
                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Trip Distance</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.trip_details.trip_distance} km</Typography>
                        </Grid2>
                        <hr/>
                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Number of Stops</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.trip_details.no_of_stops}</Typography>
                        </Grid2>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={1}>
                        <Typography sx={{color:'#2A313C', fontSize:'20px', fontWeight:'600'}}>Driver Details</Typography>

                        <Grid2 container sx={{ width: "auto", minWidth: "180px", marginTop: '5%' }} spacing={1} alignItems="center">
                            <Grid2 item>
                                <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt="driverName" src={marker.driver_info.driver_image} />
                            </Grid2>

                            <Grid2 item sx={{ textAlign: "left" }}>
                                <Typography>{marker.driver_info.driver_name}</Typography>

                                {/* Star Row */}
                                <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '4px' }}>
                                {[...Array(5)].map((_, index) => (
                                    <Box key={index} sx={{ marginRight: '4px' }}>
                                    {index < marker.driver_info.total_rating ? (
                                        <img src={starIcon} alt="star" height="12px" width="12px" />
                                    ) : (
                                        // <Box sx={{ width: '12px', height: '12px' }} />
                                        <></>
                                    )}
                                    </Box>
                                ))}
                                <Typography sx={{color:'#83888E', fontSize:'12px'}}>({marker.driver_info.no_of_rating} Reviews)</Typography>
                                </Box>
                            </Grid2>
                        </Grid2>

                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Driver ID</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.driver_info.driver_id}</Typography>
                        </Grid2>
                        <hr/>
                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Mobile Number</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>
                                {driverDataShown == '0' ? marker.driver_info.driver_phone_number : (() => {
                                    if (!marker.driver_info.driver_phone_number) return '****';
                                    const phone = marker.driver_info.driver_phone_number;
                                    // Remove any non-digit characters for processing
                                    const cleanPhone = phone.replace(/\D/g, '');
                                    if (cleanPhone.length <= 4) return '****';
                                    const firstTwo = cleanPhone.substring(0, 2);
                                    const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                    const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                    return "+" + firstTwo + maskedMiddle + lastTwo;
                                })()}
                            </Typography>
                        </Grid2>
                        <hr/>
                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Email</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>
                                {driverDataShown == 0 ? marker.driver_info.driver_email : (() => {
                                    if (!marker.driver_info.driver_email) return '****';
                                    const email = marker.driver_info.driver_email;
                                    const atIndex = email.indexOf('@');
                                    if (atIndex <= 2) return '****' + email.substring(atIndex);
                                    const firstTwo = email.substring(0, 2);
                                    const domain = email.substring(atIndex);
                                    const maskedMiddle = '**'.repeat(atIndex - 2);
                                    return firstTwo + maskedMiddle + domain;
                                })()}
                            </Typography>
                        </Grid2>
                        <hr/>
                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Total Trips</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.driver_info.total_trips}</Typography>
                        </Grid2>
                        <hr/>
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={2}>
                        <Typography sx={{color:'#2A313C', fontSize:'20px', fontWeight:'600'}}>Route & Passenger Info</Typography>

                        {(marker?.trip_details?.route_details || []).map((stop, index) => (
                            <Grid2 sx={{ width: "auto", minWidth: "180px", marginTop: '5%' }} alignItems="center">
                                <Grid2 container sx={{display:'flex', alignItems:'center'}}>
                                    <img height="20px" width="20px" src={pickupMarker} alt="pickup" />
                                    <Typography sx={{marginLeft:'6px'}}>{stop.name}</Typography>
                                    <Typography
                                    sx={{
                                        marginLeft: '6px',
                                        fontWeight: 600,
                                        color: stop.is_skipped
                                        ? '#f44336' // Red
                                        : stop.is_auto_arrived
                                        ? '#ff9800' // Orange
                                        : stop.is_arrived
                                        ? '#4caf50' // Green
                                        : '#ccccccff', // Grey
                                    }}
                                    >
                                    {stop.is_skipped
                                        ? 'Skipped'
                                        : stop.is_auto_arrived
                                        ? 'Arrived (Auto)'
                                        : stop.is_arrived
                                        ? 'Arrived'
                                        : 'Pending'}
                                    </Typography>
                                    <Grid2 item sx={{border: '1px solid #D1D5DB', borderRadius:'8px', padding:'4px 8px', marginLeft:'auto', marginRight:'2%'}}>
                                        <Typography sx={{color:'#83888E'}}> 
                                        {new Date(stop.reach_timestamp).toLocaleTimeString([], {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true
                                        })}
                                            {/* {new Date(stop.reach_timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} */}
                                        </Typography>
                                    </Grid2>
                                </Grid2>

                                <Grid2>
                                    {/* make horizontally scrollable cards */}
                                </Grid2>

                                <Grid2 item sx={{padding:'12px'}}>
                                    <Typography sx={{color:'#83888E', marginLeft:'4%'}}>{stop.address}</Typography>

                                    {/* <Grid2 container spacing={1} sx={{marginTop:'12px', marginLeft:'4%'}}>
                                        {stop.stop_image.split(';;').map((url, index) => (
                                            <Grid2 item key={index}>
                                            <img
                                                src={url}
                                                alt={`Uploaded ${index}`}
                                                style={{
                                                width: "150px",
                                                height: "100px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                }}
                                            />
                                            </Grid2>
                                        ))}
                                    </Grid2> */}
                                    <Box sx={{ overflowX: 'auto', width: '100%' }}>
                                        <Grid2
                                            container
                                            spacing={1}
                                            sx={{
                                            marginTop: '12px',
                                            marginLeft: '4%',
                                            flexWrap: 'nowrap', // prevent wrapping
                                            width: 'max-content', // ensure content takes full width
                                            }}
                                        >
                                            {stop.stop_image?.split(';;').filter(Boolean).map((url, index) => (
                                            <Grid2 item key={index}>
                                                <img
                                                src={url}
                                                alt={`Uploaded ${index}`}
                                                style={{
                                                    width: "154px",
                                                    height: "102px",
                                                    objectFit: "cover",
                                                    borderRadius: "8px",
                                                }}
                                                />
                                            </Grid2>
                                            ))}
                                        </Grid2>
                                    </Box>


                                    <hr
                                        style={{
                                            border: "none",
                                            borderTop: "2px dotted #D1D5DB",
                                            margin: "16px 0"
                                        }}
                                    />

                                    <Grid2 container spacing={3} sx={{justifyContent:'space-between', marginLeft:'4%'}}>
                                        <Grid2 item>
                                            <Typography sx={{color:'#83888E', fontSize:'12px', marginBottom:'4%'}}>On-Board</Typography>
                                            <Grid2 item sx={{border:'1px solid #0DBA78', padding:'4px 8px', borderRadius:'6px', display:'flex'}}>
                                                <ArrowUpwardIcon sx={{color:'#0DBA78'}}/>
                                                <Typography sx={{color:'#0DBA78'}}>{stop.onboard_passengers_count}</Typography>
                                            </Grid2>
                                        </Grid2>

                                        <Grid2 item>
                                            <Typography sx={{color:'#83888E', fontSize:'12px', marginBottom:'4%'}}>Off-Board</Typography>
                                            <Grid2 item sx={{border:'1px solid #C71F1F', padding:'4px 8px', borderRadius:'6px', display:'flex'}}>
                                                <ArrowUpwardIcon sx={{color:'#C71F1F'}}/>
                                                <Typography sx={{color:'#C71F1F'}}>{stop.offboard_passengers_count}</Typography>
                                            </Grid2>
                                        </Grid2>

                                        <Grid2 item sx={{border:'1px solid #D1D5DB', borderRadius:'6px', marginTop:'6%'}}>
                                            <Button sx={{backgroundColor:'#F9F9F9', textTransform:'none', padding:'6px 12px'}} onClick={() => openPassengerDetails(stop)}>
                                                <Typography sx={{color:'#4E545D', fontSize:'14px'}}>View All Passengers</Typography>
                                            </Button>
                                        </Grid2>
                                    </Grid2>

                                    <hr style={{borderTop:'1px solid #D1D5DB', margin: "16px 0"}}/>
                                </Grid2>
                            </Grid2>
                        ))} 
                        {/* (mapViewData.map((marker, index) => ( */}
                                
                        
                    </CustomTabPanel>

                    <CustomTabPanel value={value} index={3}>
                        <Typography sx={{color:'#2A313C', fontSize:'20px', fontWeight:'600'}}>Vehicle Details</Typography>

                        <Grid2 container sx={{ width: "auto", minWidth: "180px", marginTop: '5%' }} spacing={1} alignItems="center">
                            <Grid2 item>
                                {marker.vehicle_info.image=='' && (
                                    <img src={shuttleDetails} alt="shuttle img" />
                                )}
                                {marker.vehicle_info.image!='' && (
                                    <img src={marker.vehicle_info.image} width="60px" height="60px" alt="shuttle img" />
                                )}
                            </Grid2>

                            <Grid2 item sx={{ textAlign: "left", marginLeft:'8px' }}>
                                <Typography>{marker.vehicle_info.brand}</Typography>
                                <Typography sx={{fontSize:'12px', color:'#83888E'}}>{marker.vehicle_info.model_name}</Typography>
                            </Grid2>
                        </Grid2>

                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Vehicle Number</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.trip_details.vehicle_number}</Typography>
                        </Grid2>
                        <hr/>
                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Vehicle Type</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>Shuttle</Typography>
                        </Grid2>
                        <hr/>
                        <Grid2 sx={{marginTop:'5%'}}>
                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Seat Capacity</Typography>
                            <Typography sx={{fontSize:'16px', marginTop:'1%'}}>{marker.vehicle_info.no_of_seats}</Typography>
                        </Grid2>
                        <hr/>
                    </CustomTabPanel>
                </Grid2>

                <Grid2 item size={7.5} className="mainBox" sx={{marginTop:'1%'}}>
                    {isLoaded ? (
                        <GoogleMap
                            mapContainerStyle={containerStyle}
                            center={center}
                            zoom={12}
                            onLoad={onLoad}
                            onUnmount={onUnmount}
                        >
                            {/* Render markers for each stop */}
                            {polylineVisible && marker?.trip_details?.route_details?.map((stop, index) => {
                                let markerIcon;
                                if (index === 0) {
                                    markerIcon = {
                                        url: pickupMarker,
                                        scaledSize: new window.google.maps.Size(40, 40)
                                    };
                                } else if (index === marker.trip_details.route_details.length - 1) {
                                    markerIcon = {
                                        url: dropMarker,
                                        scaledSize: new window.google.maps.Size(40, 40)
                                    };
                                } else {
                                    // For intermediate stops
                                    if (stop.is_skipped) {
                                        markerIcon = {
                                            url: yellowRouteMarker,
                                            scaledSize: new window.google.maps.Size(40, 40)
                                        };
                                    } else if (!stop.is_arrived && !stop.is_skipped) {
                                        markerIcon = {
                                            url: greyRouteMarker,
                                            scaledSize: new window.google.maps.Size(40, 40)
                                        };
                                    } else {
                                        markerIcon = {
                                            url: routeMarker,
                                            scaledSize: new window.google.maps.Size(40, 40)
                                        };
                                    }
                                }

                                return (
                                    <Marker 
                                        key={`stop-${index}`}
                                        position={{
                                            lat: Number(stop.latitude),
                                            lng: Number(stop.longitude)
                                        }}
                                        icon={markerIcon}
                                        label={{
                                            text: `${index + 1}`,
                                            color: "#0065FF",
                                            fontWeight: "bold",
                                            fontSize: "16px"
                                        }}
                                        zIndex={index === 0 || index === marker.trip_details.route_details.length - 1 ? 2 : 1}
                                        onClick={() => openPassengerDetails(stop)}
                                    />
                                );
                            })}

                            {/* Grey Polyline for remaining stops */}
                            {polylineVisible && greyPath.length > 1 && (
                                <Polyline
                                    path={greyPath}
                                    options={{
                                        strokeColor: "#808080",
                                        strokeOpacity: 1.0,
                                        strokeWeight: 4,
                                        zIndex: 0
                                    }}
                                />
                            )}

                            {/* Blue Polyline for completed stops */}
                            {polylineVisible && bluePath.length > 1 && (
                                <Polyline
                                    path={bluePath}
                                    options={{
                                        strokeColor: "#0065FF",
                                        strokeOpacity: 1.0,
                                        strokeWeight: 4,
                                        zIndex: 1
                                    }}
                                />
                            )}
                        </GoogleMap>
                        
                    ): (<></>)}
                </Grid2>
            </Grid2>

            {/* {openPassengerModal && ( */}
                <Modal open={openPassengerModal} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Passenger Details
                        </Typography>

                        <Grid2>
                            <Typography sx={{color:'#0065ff', fontSize:'12px', marginTop:'4px', marginBottom:'4px'}}>Current Stop</Typography>

                            <Grid2 item sx={{border: '1px solid #D1D5DB', borderRadius:'8px'}}>
                                <Grid2 container sx={{alignItems:'center', padding:'6px'}}>
                                    <Grid2 item>
                                        <img src={currentStopIcon} alt="pickup" height='20px' width='20px' />
                                    </Grid2>
                                    <Grid2 item sx={{marginLeft:'12px'}}>
                                        <Typography>{currentStopName}</Typography>
                                        <Typography sx={{fontSize:'14px', color:'#83888E'}}>{currentStopAddress}</Typography>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                        <hr/>

                        <Grid2 container size={12}>
                            <Grid2 item size={6}>
                                <Typography sx={{marginBottom:'12px', marginTop:'12px'}}>Offboard Passenger List</Typography>

                                {passengerModalData?.offboard_list?.map((offboard, index) => 
                                    <Grid2 sx={{border: '1px solid #D1D5DB', borderRadius:'8px', padding:'8px', margin:'4px 20px 4px 0px'}}>
                                        <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                            <Grid2>
                                                <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='Michel' src={offboard.user_image}></Avatar>
                                            </Grid2>
                                            <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                <Grid2><Typography>{offboard.user_name}</Typography></Grid2>
                                                <Grid2>
                                                    <Typography sx={{ color: "#83888E", fontSize: "12px" }}>
                                                        {clientdataShown == '0' ? offboard.phone_number : (() => {
                                                            if (!offboard.phone_number) return '****';
                                                            const phone = offboard.phone_number;
                                                            // Remove any non-digit characters for processing
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()}
                                                    </Typography>
                                                </Grid2>
                                            </Grid2>
                                            <Grid2 item sx={{marginLeft:'auto', border:'1px solid #D1D5DB', borderRadius:'8px', display:'flex', alignItems:'center', padding:'0px 4px 0px 4px'}}>
                                                <img src={passengerSeat} alt="passengerseat" height="20px" width="20px" />
                                                <Typography sx={{padding:'4px'}}>{offboard.booked_seats.length}</Typography>
                                            </Grid2>
                                        </Grid2>
                                        <hr/>
                                        <Grid2 sx={{alignItems:'center', display:'flex'}}>
                                            <Grid2 item>
                                                <img src={redDropIcon} alt='pickup' height="20px" width='20px' />
                                            </Grid2>
                                            <Grid2 item sx={{marginLeft:'12px'}}>
                                                <Typography sx={{fontSize:'12px', color:'#83888E'}}>Drop Point</Typography>
                                                <Typography>{offboard.drop_stop_address}</Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                )}
                            </Grid2>

                            <Grid2 item size={6}>
                                <Typography sx={{marginBottom:'12px', marginTop:'12px'}}>Onboard Passenger List</Typography>

                                {passengerModalData.onboard_list?.map((onboard, index) => 
                                    <Grid2 sx={{border: '1px solid #D1D5DB', borderRadius:'8px', padding:'8px', margin:'4px 4px 4px 0px'}}>
                                        <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                            <Grid2>
                                                <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='Michel' src={onboard.user_image}></Avatar>
                                            </Grid2>
                                            <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                <Grid2><Typography>{onboard.user_name}</Typography></Grid2>
                                                <Grid2>
                                                    <Typography sx={{ color: "#83888E", fontSize: "12px" }}>
                                                        {clientdataShown == '0' ? onboard.phone_number : (() => {
                                                            if (!onboard.phone_number) return '****';
                                                            const phone = onboard.phone_number;
                                                            // Remove any non-digit characters for processing
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()}
                                                    </Typography>
                                                </Grid2>
                                            </Grid2>
                                            <Grid2 item sx={{marginLeft:'auto', border:'1px solid #D1D5DB', borderRadius:'8px', display:'flex', alignItems:'center', padding:'0px 4px 0px 4px'}}>
                                                <img src={passengerSeat} alt="passengerseat" height="20px" width="20px" />
                                                <Typography sx={{padding:'4px'}}>{onboard.booked_seats.length}</Typography>
                                            </Grid2>
                                        </Grid2>
                                        <hr/>
                                        <Grid2 sx={{alignItems:'center', display:'flex'}}>
                                            <Grid2 item>
                                                <img src={pickupMarker} alt='pickup' height="20px" width='20px' />
                                            </Grid2>
                                            <Grid2 item sx={{marginLeft:'12px'}}>
                                                <Typography sx={{fontSize:'12px', color:'#83888E'}}>Pickup Point</Typography>
                                                <Typography>{onboard.pickup_stop_address}</Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                )}
                            </Grid2>
                        </Grid2>
                    </Box>
                </Modal>
            {/* )} */}
        </div>
    )
}

export default ShuttleMapViewDetails;